<template>
  <div>
    <div class="landing-cnt row">
      <div class="bg-heart"></div>
      <div class="bg-image"></div>
      <div class="col-12 d-landscape-none d-xl-none d-flex main-block-xs"></div>
      <!-- Main text block not logged -->
      <div class="text-block-ctn col-desktop-6 col-landscape-6 col-xl-6 col-12 d-flex my-auto pt-4 pt-md-0">
        <div class="text-ctn my-auto">
          <h1 v-html="$t('os360-empresas.main-block.title')"></h1>
          <h3>{{ $t('os360-empresas.main-block.subtitle') }}</h3>
          <p class="d-mobile-rotated-none">
            {{ $t('os360-empresas.main-block.paragraph')}}
          </p>
          <div class="btn-cnt mt-0 mt-mobile-rotated-4 mt-xl-5">
            <base-button class="mr-2 mr-md-4" pseudoShadow @click="goToContactForm">+ Info
            </base-button>
            <base-button white pseudoShadow :textColor="BLUE_COLOUR" @click="goTo360SignIn">
              {{ $t('log-in') }}</base-button>
          </div>
        </div>
      </div>
    </div>

    <b-row id="service-blocks" class="section py-5">
      <b-row class="neu-cards-ctn m-auto text-center" cols="1" cols-sm="2" cols-xl="3">
        <b-col class="my-auto">
          <div class="box bg-heart-sm">
            <div class="my-auto">
              <h3 class="main-title">{{  $t('os360-empresas.blocks.title') }} <br>opensalud360</h3>
              <br>
              <h5 class="d-block">{{ $t('os360-empresas.blocks.what-do-you-need') }}</h5>
            </div>
          </div>
        </b-col>
        <!-- <PatientPanelServiceBlock v-for="block in blocks" :id="block.id" :title="block.title" :description="block.description" :img="block.img" visible active :key="block.id"/> -->
        <b-col v-for="block in blocks" :key="block.id" class="my-auto">
          <div class="box my-auto">
            <div class="my-auto">
              <base-icon blue :src="block.img" :alt="block.title" class="d-block" size="lg" />
              <span class="box-title mt-3">{{ block.title }}</span>
              <p>{{ block.description }}</p>
              <b-badge class="mt-4" v-if="inMx && block.title === $t('os360-empresas.blocks.opensaludpass.title')">{{ $t('os360-empresas.blocks.opensaludpass.soon') }}</b-badge>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="6" xl="8" class="my-auto">
          <div class="box bg-heart-big">
            <div class="my-auto">
              <h3 class="d-block">{{  $t('os360-empresas.blocks.more-info-question') }}</h3>
              <base-button white shadow class="mt-2 mt-md-4" @click="goToContactForm">
                {{  $t('os360-empresas.big-companies.request-info') }}</base-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-row>

    <b-row id="social-benefit" class="section-black-list" v-if="!inMx">
      <b-col md="12" xl="6" class="d-none d-xl-block">
        <div class="col-bg ml-lg-auto">
        </div>
      </b-col>
      <b-col md="12" xl="6" class="content my-auto mx-auto">
        <h3>{{  $t('os360-empresas.social-benefit.subtitle') }}</h3>
        <div class="subtitle pt-4">
          <!-- <p>{{  $t('os360-empresas.social-benefit.subtitle') }}</p> -->
          <div class="subtitle-list subtitle-list-large">
            <!-- Loop of i < 6 -->
            <b-row v-for="i in [1,2,3,4,5,6]" :key="i">
              <b-col class="tick-mobile" cols="1">
                <p>
                  <base-icon :src="`/static-appopensalud/img/icons/360/social-benefit-${i}.svg`" width="30" height="30"/>
                </p>
              </b-col>
              <b-col cols="10" offset="1" offset-md="0" class="my-auto">
                <span>
                  {{ $t(`os360-empresas.social-benefit.list.${i}`) }}
                </span>
              </b-col>
            </b-row>
          </div>
          <p style="color: white;">{{  $t('os360-empresas.social-benefit.security-description') }}</p>
        </div>
        <b-row class="cert-icons mt-3 mt-md-5">
          <div class="d-inline-block">
            <ISO27001Logo/>
          </div>
          <div class="d-inline-block">
            <img class="vertical" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/gdpr.webp" />
          </div>
        </b-row>
      </b-col>
    </b-row>

    <b-row id="big-companies" class="section mx-auto py-5">
      <div class="my-auto text-center">
        <b-col cols="12">
          <h5>
            {{ $t('os360-empresas.companies') }}
          </h5>
          <h6 v-html="$t('os360-empresas.companies2')" class="desktop-fix-subtitle">
          </h6>
        </b-col>
        <b-col cols="12" class="logos-ctn col-12">
					<b-row class="logos-row mt-0 mt-sm-5" v-for="groupOfLogos in groupsOfLogos" :key="groupsOfLogos.indexOf(groupOfLogos)">
						<b-col v-for="logo in groupOfLogos" cols="12" sm="2" :offset-sm="groupOfLogos.indexOf(logo) == 0 ? 1 : null" :offset-md="groupOfLogos.indexOf(logo) == 0 ? 1 : null" md="2" :key="logo.companyName">
							<img :src="logo.logo" :alt="logo.companyName" :style="{ 'width': logo.width && !$uiHelpers.isMobile && !$uiHelpers.isTablet }">
						</b-col>
					</b-row>
        </b-col>
      </div>
    </b-row>

    <b-row id="psychological-attention" class="section-invert">
      <b-col md="12" xl="6" class="content my-auto mx-auto">
        <h3>{{  $t('os360-empresas.psychological-attention.title') }}</h3>
        <div class="subtitle">
          <b-row>
              <b-col class="pr-lg-5 pr-sm-0" sm="12" lg="12">
                <div>
                  <p>{{ $t('os360-empresas.psychological-attention.subtitle') }}</p>
                </div>
                <span v-html="$t('os360-empresas.psychological-attention.text')"></span>
                <br>
                <span v-html="$t('os360-empresas.psychological-attention.subtitle-2')"></span>
              </b-col>
              <b-col sm="12" lg="12">
                <div>
                  <p>{{ $t('os360-empresas.psychological-attention.title-2') }}</p>
                </div>
                <span v-html="$t('os360-empresas.psychological-attention.text-2')"></span>
                <img class="d-block d-desktop-none d-xl-none" src="/static-appopensalud/img/logos/logo-menttum-grande-blanco.png" alt="Menttum"/>
              </b-col>
              <base-button @click="goToContactForm" white class="mt-5">
                {{ $t('os360-empresas.more-information-btn') }}</base-button>
            </b-row>
        </div>
      </b-col>
      <b-col md="12" xl="6" class="d-none d-desktop-block d-xl-block">
        <img src="/static-appopensalud/img/logos/logo-menttum-grande.png" alt="Menttum" class="m-auto justify-content-center align-items-center" />
        <div class="col-bg ml-xl-auto">
          
        </div>
      </b-col>
    </b-row>

    <!-- <b-row id="psychological-attention" class="section py-lg-5 py-0" v-if="!inMx">
      <b-col class="my-auto content" cols="12">
        <b-col sm="12" lg="6" class="pr-lg-5 pr-sm-0">
          <h3>{{ $t('os360-empresas.psychological-attention.title') }}</h3>
        </b-col>
        <b-row>
          <b-col class="pr-lg-5 pr-sm-0" sm="12" lg="6">
            <div class="subtitle">
              <p>{{ $t('os360-empresas.psychological-attention.subtitle') }}</p>
            </div>
            <span v-html="$t('os360-empresas.psychological-attention.text')">
            </span>
            <base-button @click="goToContactForm" outline shadow class="d-lg-block d-none mt-5">
              {{ $t('os360-empresas.more-information-btn') }}</base-button>
          </b-col>
          <b-col sm="12" lg="6" class="pl-lg-5 pl-sm-0">
            <div class="subtitle">
              <p>{{ $t('os360-empresas.psychological-attention.title-2') }}</p>
            </div>
            <span v-html="$t('os360-empresas.psychological-attention.subtitle-2')"></span>
            <img src="/static-appopensalud/img/logos/logo-menttum-grande.png" alt="Menttum" class="w-75 d-block" />
            <base-button v-if="!$uiHelpers.isMobile" @click="goToContactForm" outline shadow class="d-lg-none mt-5">
              {{ $t('os360-empresas.more-information-btn') }}</base-button>
          </b-col>
          <base-button v-if="$uiHelpers.isMobile" @click="goToContactForm" outline shadow class="d-lg-none mt-5">
            {{ $t('os360-empresas.more-information-btn') }}</base-button>
        </b-row>
      </b-col>
    </b-row> -->

    <!-- <div id="wellness-services" v-if="!inMx">
      <neu-cards-slider2 cols=3 class="section py-lg-5 py-0" :cards="wellnessCards">
        <template v-slot:heading>
          <h3 v-html="$t('os360-empresas.wellness-services.title')"></h3>
          <div class="subtitle w-100">
            <p>{{ $t('os360-empresas.wellness-services.subtitle') }}</p>
          </div>
        </template>
      </neu-cards-slider2>
    </div> -->

    <companies-contact-form class="pb-5 pb-xl-0" style="margin-top:0px !important;padding-top:3rem !important" forCompaniesOnly hideWebsite showReason :subtitle="$t('os360-empresas.opensalud-empresas.form-subtitle')" callbackPath="/opensalud360/empresas/gracias"></companies-contact-form>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import NeuCardsSlider2 from '@/components/base/ui/NeuCardsSlider2.vue'
import layoutMixin from '@/mixins/layout.mixin'
import { BLUE_COLOUR } from '@/constants/colours'
import RoundedCheckIcon from '@/components/base/icons/RoundedCheckIcon.vue'
import CompaniesContactForm from '@/components/forms/CompaniesContactForm.vue'
import ISO27001Logo from '@/components/utils/ISO27001Logo.vue'
import { inMx } from '@/helpers/global.helpers'

export default {
  mixins: [layoutMixin],
  components: {
    NeuCardsSlider2,
    RoundedCheckIcon,
    BBadge,
		CompaniesContactForm,
		ISO27001Logo
  },
  data () {
    return {
			inMx,
      BLUE_COLOUR,
      /* wellnessCards: [
        {
          title: this.$t('os360-empresas.wellness-services.cards.1.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.1.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/yoga.svg',
          type: 0
        },
        {
          title: this.$t('os360-empresas.wellness-services.cards.2.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.2.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/wellbeing-mindset.svg',
          type: 0
        },
        {
          title: this.$t('os360-empresas.wellness-services.cards.3.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.3.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/environment-wellbeing.svg',
          type: 0
        },
        {
          title: this.$t('os360-empresas.wellness-services.cards.4.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.4.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/social-wellbeing.svg',
          type: 0
        }
      ], */
      blocks: [
        {
          title: this.$t('os360-empresas.blocks.teleconsultation.title'),
          description: this.$t('os360-empresas.blocks.teleconsultation.description'),
          img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/medic.svg'
        },
        {
          title: this.$t('os360-empresas.blocks.wellness.title'),
          description: this.$t('os360-empresas.blocks.wellness.description'),
          img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/hand-holding-heart.svg'
        },
        {
          title: this.$t('os360-empresas.blocks.evaluate-your-health.title'),
          description: this.$t('os360-empresas.blocks.evaluate-your-health.description'),
          img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/self-test.svg'
        },
        {
          title: this.$t('os360-empresas.blocks.healthy-habits.title'),
          description: this.$t('os360-empresas.blocks.healthy-habits.description'),
          img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/habits-food.svg'
        },
        {
          title: this.$t('os360-empresas.blocks.opensaludpass.title'),
          description: this.$t('os360-empresas.blocks.opensaludpass.description'),
          img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/creditcard.svg'
        },
				{
					title: this.$t('os360-empresas.blocks.digital-phisiotherapy.title'),
					description: this.$t('os360-empresas.blocks.digital-phisiotherapy.description'),
					img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/fisio-digital.svg'
				}
/*         {
          title: this.$t('os360-empresas.blocks.healthy-community.title'),
          description: this.$t('os360-empresas.blocks.healthy-community.description'),
          img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/healthy-community.svg'
        } */
      ],
			companyLogos: [
				{
					name: 'AON',
					logo: '/static-appopensalud/img/logos/aon.svg',
					width: '40%'
				},
				{
					name: 'Barcelo',
					logo: '/static-appopensalud/img/logos/barcelo.svg',
					width: '65%'
				},
				{
					name: 'IKEA',
					logo: '/static-appopensalud/img/logos/_IKEA.svg',
					width: '40%'
				},
				{
					name: 'Mahou San Miguel',
					logo: '/static-appopensalud/img/logos/msm.svg'
				},
				{
					name: 'Scania',
					logo: '/static-appopensalud/img/logos/scania.png',
					width: '65%'
				},
				{
					name: 'Siemens',
					logo: '/static-appopensalud/img/logos/siemens.svg'
				},
				{
					name: 'Santander',
					logo: '/static-appopensalud/img/logos/santander.svg',
					width: '65%'
				},
				{
					name: 'Novo Nordisk',
					logo: '/static-appopensalud/img/logos/novo-nordisk.svg'
				},
				{
					name: 'Iveco',
					logo: '/static-appopensalud/img/logos/IVECO_2.svg'
				},
				{
					name: 'Loreal',
					logo: '/static-appopensalud/img/logos/loreal.svg',
					width: '65%'
				}
			]
    }
  },
  methods: {
    goToContactForm () {
      this.goToSection('contact-form', 1500)
    },
    goToSection (section, duration = 500) {
      this.$scrollTo(`#${section}`, duration, {
        container: 'body',
        easing: 'ease-in',
        lazy: false,
        force: true,
        cancelable: true,
        onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel () {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      })
    },
    goTo360SignIn () {
      window.location.href = this.$helpers.get360AppUrl('inicio-sesion')
    }
  },
	computed: {
		groupsOfLogos () {
			// Divide array in groups of 5
			return this.companyLogos.reduce((acc, curr, i) => {
				if (!(i % 5)) {
					acc.push([])
				}
				acc[acc.length - 1].push(curr)
				return acc
			}, [])
		}
	}
}
</script>

<style lang="scss" scoped>
  @import "static-appopensalud/css/public/views/opensalud_empresas.scss";
  @import "static-appopensalud/css/public/layout.scss";
  /deep/ {
    .neu-card-general-ctn {
  // margin-top: 5rem;
  @include tablets {
    margin-left: 1rem;
  }

  @include mobile {
    padding: {
      left: 2rem;
      right: 2rem;
    }
  }
  > div {
    &:not(:last-child) {
      @include desktop {
        margin-right: 2rem;
      }
      
      @include media(desktop-sm, tablets, mobile) {
        margin-right: 2rem;
      }
    }

    cursor: pointer;
  }
}
.neu-card-general {
  
  @include desktop-sm {
    padding: .5rem;
  }

  @include media(mobile, tablets) {
    padding: 1rem;
    margin: {
      bottom: 2rem;
    }
  }
  
  background-color: $white;
  transition: all .5s ease;

  &:hover {
    border: 2px solid $blue;
  }
  text-align: center;

  @include media(mobile, desktop) {
    min-height: 300px;
    margin-right: 2%;
  }
  
  @include tablets {
    min-height: 300px;
  }

  margin: {
    top: auto;
    bottom: auto;
  }

  p {
    color: $blue;
    font-weight: bold;
  }

  img {
    width: 20%;
  }

  div {
    // top: 50%;
    // left: 50%;
    // margin-right: -50%;
    // transform: translate(-50%, -50%);
    // position: absolute;

    // @include desktop {
    //   padding: 2.5rem;
    // }
    
    // @include desktop-sm {
    //   padding: 0.5rem;
    // }
  }
}
  }

  .navbar-mobile{
    padding-left: 0rem !important;
  }
  .btn-mobile{
    background-color: white !important;
    width: 4.5rem;
    font-size:0.8rem  !important;
    padding-left:0rem !important;
  }
.flex-mobile-lang {
  display:inline-flex !important;
}
.desktop-fix {
  @include desktop {
    padding: {
      left: 20rem;
      right: 20rem;
      top: 3rem;
    }
  }

  @include tablets {
    padding: {
      left: 0rem;
      right: 0rem;
    }
  }

  @include mobile {
    padding: {
      top: 0rem;
    };
  }

}
.desktop-fix-subtitle {
  padding-top: 1rem !important;
  @include desktop(){
    padding-left: 20rem;
    padding-right: 20rem;
  }
   @include tablets(){
    padding: {
      left: 0rem;
      right: 0rem;
    }
  }
   @include mobile(){
    padding: {
      left: 0rem;
      right: 0rem;
    }
  }
}


.column_wrapper {
  column-count: 3;
}

.v-dialog--active .v-card__title {
  color: #3238C4;
  justify-content: center;
  word-break:break-word;
}
.v-dialog__content .v-dialog--active .v-card__text ul li {
  margin-top: 5px;
}
@media (max-width: 1268px) {
  #discounts > div.content.my-auto.col-md-12.col-lg-6 > div > div > div > p {
    font-size: 1rem;
  }
}
@media (max-width: 960px) {
  .v-dialog__content .v-dialog--active {
    width: 85vw;
  }
  .column_wrapper{
    column-count: 1;
  }
  #discounts .subtitle{
    width: 100%;
  }
}
@media (max-width: 960px) and (orientation: landscape) {
  .column_wrapper{
    column-count: 3;
  }
}

@include desktop {
  .section-black-list {
    h3 {
      font-size: 2.5rem;
    }
  }
}

@include mobile {
  .section-black-list .subtitle .subtitle-list > div {
    margin-bottom: 1rem;
  }

  /deep/ .mobile {
    padding-top: 0rem !important;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/views/opensalud/EmpresasNew.vue